import { createPinia } from 'pinia'

// Shared Pinia instance used by the app and any out-of-component store access.
export const pinia = createPinia()

